import { createBrowserHistory } from 'history';
import routerLogger from 'helpers/routerLogger';

const history = createBrowserHistory({
  basename: '/app',
});

routerLogger(history);

export default history;
